var _defs, _rect, _rect2, _path, _rect3, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThemePreviewDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 57,
    viewBox: "0 0 90 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 57,
    rx: 4,
    transform: "translate(718 420)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-40.172a81.071,81.071,0,0,1,18.365-2.864c.243-.009.447.134.447.313s-.175.3-.4.312A102.312,102.312,0,0,0,1.049-40.172c0,.027-1.049.16-1.049,0m16.506-6.485a3.078,3.078,0,0,1,.428-.658c.04.02-.047.307-.274.695a4.805,4.805,0,0,1-.668.884c.047-.113.341-.622.514-.92M4.193-46.35a.586.586,0,0,1,.407.079.978.978,0,0,1,.354.494.907.907,0,0,1-.2.672c-.16.222-.354.573-.447.736-.06.108-.134.168-.261.059a.391.391,0,0,1-.16-.318,1.375,1.375,0,0,1,.307-.693l.054-.083.035-.056c.134-.214.241-.424.165-.465-.247-.137-1.71.974-1.744,1.7-.02.417.9.656,1.155.8a.344.344,0,0,1,.2.294A.947.947,0,0,1,3.8-42.6a1.414,1.414,0,0,1-.9.437,2.1,2.1,0,0,1-1.664-.613c-.093-.095-.047-.17.047-.213a1.015,1.015,0,0,1,.207-.046.789.789,0,0,1,.521.09,1.836,1.836,0,0,0,1.089.374.6.6,0,0,0,.354-.146.163.163,0,0,0-.007-.263,5.207,5.207,0,0,0-.473-.234l-.08-.037c-.427-.2-.857-.441-.857-.877,0-.854,1.042-1.735,1.644-2.052A1.388,1.388,0,0,1,4.193-46.35Zm12.52-1.508c.127-.136.247-.189.374-.092a.518.518,0,0,1,.22.43.827.827,0,0,1-.04.269A4.449,4.449,0,0,1,15.744-45.2a2.555,2.555,0,0,0-.221.851c0,.151.04.252.127.241.307-.04.695-.511.949-1a.3.3,0,0,1,.084-.1c.14-.216.305-.456.477-.678a.273.273,0,0,1-.127-.216,1.153,1.153,0,0,1,.634-.848c.14-.018.2.049.2.194a1.807,1.807,0,0,1-.12.518,1.944,1.944,0,0,0,.541-.334c.114-.09.18-.111.267-.041a.531.531,0,0,1,.194.377.426.426,0,0,1-.107.258,2.8,2.8,0,0,0-.741,1.352c0,.163.053.257.147.244.227-.029.494-.415.7-.875.053-.12.147-.138.207-.033a.5.5,0,0,1-.02.411,1.286,1.286,0,0,1-.935.749.5.5,0,0,1-.628-.528,2.723,2.723,0,0,1,.688-1.357,1.621,1.621,0,0,1-.488.164A9.025,9.025,0,0,0,16.6-43.9c-.027.116-.114.184-.234.08a.41.41,0,0,1-.159-.27,1.309,1.309,0,0,1-.549.224.509.509,0,0,1-.627-.331,1.539,1.539,0,0,1-.9.547c-.454.059-.7-.142-.7-.481a1.053,1.053,0,0,1,.1-.421c.107-.227.328-.595.481-.841.147-.226.307-.435.254-.428s-.194.088-.588.509a6.423,6.423,0,0,0-1.122,1.815c-.067.128-.16.159-.267.072a.362.362,0,0,1-.147-.326,1.6,1.6,0,0,1,.12-.48,6.648,6.648,0,0,1,.494-.892c.181-.306.368-.569.307-.561a2.334,2.334,0,0,0-.715.645,6.306,6.306,0,0,0-.942,1.647c-.047.107-.12.154-.234.074a.359.359,0,0,1-.115-.125,1.257,1.257,0,0,1-.6.28c-.394.051-.595-.105-.621-.384A1.449,1.449,0,0,1,8.97-43a.367.367,0,0,1-.43-.214,1.463,1.463,0,0,1-.752.386.529.529,0,0,1-.662-.561,3.149,3.149,0,0,1,.722-1.424,1.885,1.885,0,0,1-.521.181C6.845-43.562,6.1-42.611,5.249-42.5c-.615.08-.949-.253-.949-.743a1.728,1.728,0,0,1,.2-.748A2.031,2.031,0,0,1,5.77-45.148a.446.446,0,0,1,.234.02.8.8,0,0,1,.394.307c.1.188-.007.428-.134.689a2.3,2.3,0,0,0-.12.273c-.047.138-.073.173-.24.113a.34.34,0,0,1-.234-.334,1.767,1.767,0,0,1,.154-.466c.067-.141.133-.275.1-.3-.087-.052-.515.387-.8.956a1.772,1.772,0,0,0-.2.723c0,.264.114.425.307.412.655-.06,1.369-1.069,1.717-1.886a.238.238,0,0,1-.187-.252,1.2,1.2,0,0,1,.668-.884c.14-.018.194.057.194.195a1.965,1.965,0,0,1-.127.544,2.023,2.023,0,0,0,.581-.345c.1-.082.207-.121.294-.044a.554.554,0,0,1,.187.4.422.422,0,0,1-.114.266,4.088,4.088,0,0,0-.722,1.148.9.9,0,0,0-.053.289c0,.157.053.244.154.238.211-.01.554-.4.762-.826a8.193,8.193,0,0,1,.895-1.667.177.177,0,0,1,.287-.037.4.4,0,0,1,.1.276,3.537,3.537,0,0,1-.421.969l-.055.1c-.091.173-.178.343-.245.49-.12.267-.14.5.007.482.174-.023.528-.5.869-1.041.394-.654.568-1.1.808-1.423.094-.131.2-.17.281-.074a.455.455,0,0,1,.1.314,2.113,2.113,0,0,1-.374.9,2.858,2.858,0,0,0-.454,1.025c0,.113.04.171.127.159.161-.021.387-.283.591-.59a13.388,13.388,0,0,1,1.012-1.922c.087-.13.187-.137.254-.033a.513.513,0,0,1,.094.289.838.838,0,0,1-.02.172,2.093,2.093,0,0,1,.875-.616c.214-.028.354.18.354.444a2.018,2.018,0,0,1,.868-.571c.194-.019.3.137.3.344a2.108,2.108,0,0,1-.414.951,1.874,1.874,0,0,0-.361.812c0,.145.067.236.174.223.207-.027.534-.509.782-.924a.251.251,0,0,1,.052-.064A8.157,8.157,0,0,1,16.713-47.858Z",
    transform: "translate(0 48)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-62,84.666H180.675V-84H-62Z",
    transform: "translate(62 84)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-40.094H19.043V-48H0Z",
    transform: "translate(0 48)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3-43.172a81.071,81.071,0,0,1,18.365-2.864c.243-.009.447.134.447.313s-.175.3-.4.312A102.313,102.313,0,0,0,4.049-43.172c0,.027-1.049.16-1.049,0m16.506-6.485a3.078,3.078,0,0,1,.428-.658c.04.02-.047.307-.274.695a4.805,4.805,0,0,1-.668.884c.047-.113.341-.622.514-.92M7.193-49.35a.586.586,0,0,1,.407.079.978.978,0,0,1,.354.494.907.907,0,0,1-.2.672c-.16.222-.354.573-.447.736-.06.108-.134.168-.261.059a.391.391,0,0,1-.16-.318,1.375,1.375,0,0,1,.307-.693l.054-.083.035-.056c.134-.214.241-.424.165-.465-.247-.137-1.71.974-1.744,1.7-.02.417.9.656,1.155.8a.344.344,0,0,1,.2.294A.947.947,0,0,1,6.8-45.6a1.414,1.414,0,0,1-.9.437,2.105,2.105,0,0,1-1.664-.613c-.093-.095-.047-.17.047-.213a1.015,1.015,0,0,1,.207-.046.789.789,0,0,1,.521.09,1.836,1.836,0,0,0,1.089.374.6.6,0,0,0,.354-.146.163.163,0,0,0-.007-.263,5.209,5.209,0,0,0-.473-.234l-.08-.037c-.427-.2-.857-.441-.857-.877,0-.854,1.042-1.735,1.644-2.052A1.388,1.388,0,0,1,7.193-49.35Zm12.52-1.508c.127-.136.247-.189.374-.092a.518.518,0,0,1,.22.43.827.827,0,0,1-.04.269A4.449,4.449,0,0,1,18.744-48.2a2.555,2.555,0,0,0-.221.851c0,.151.04.252.127.241.307-.04.695-.511.949-1a.3.3,0,0,1,.084-.1c.14-.216.305-.456.477-.678a.273.273,0,0,1-.127-.216,1.153,1.153,0,0,1,.634-.848c.14-.018.2.049.2.194a1.807,1.807,0,0,1-.12.518,1.944,1.944,0,0,0,.541-.334c.114-.09.18-.111.267-.041a.531.531,0,0,1,.194.377.426.426,0,0,1-.107.258,2.8,2.8,0,0,0-.741,1.352c0,.163.053.257.147.244.227-.029.494-.415.7-.875.053-.12.147-.138.207-.033a.5.5,0,0,1-.02.411,1.286,1.286,0,0,1-.935.749.5.5,0,0,1-.628-.528,2.723,2.723,0,0,1,.688-1.357,1.621,1.621,0,0,1-.488.164A9.025,9.025,0,0,0,19.6-46.9c-.027.116-.114.184-.234.08a.41.41,0,0,1-.159-.27,1.308,1.308,0,0,1-.549.224.509.509,0,0,1-.627-.331,1.539,1.539,0,0,1-.9.547c-.454.059-.7-.142-.7-.481a1.053,1.053,0,0,1,.1-.421c.107-.227.328-.595.481-.841.147-.226.307-.435.254-.428s-.194.088-.588.509a6.423,6.423,0,0,0-1.122,1.815c-.067.128-.16.159-.267.072a.362.362,0,0,1-.147-.326,1.6,1.6,0,0,1,.12-.48,6.648,6.648,0,0,1,.494-.892c.181-.306.368-.569.307-.561a2.334,2.334,0,0,0-.715.645,6.306,6.306,0,0,0-.942,1.647c-.047.107-.12.154-.234.074a.359.359,0,0,1-.115-.125,1.257,1.257,0,0,1-.6.28c-.394.051-.595-.105-.621-.384A1.449,1.449,0,0,1,11.97-46a.367.367,0,0,1-.43-.214,1.463,1.463,0,0,1-.752.386.529.529,0,0,1-.662-.561,3.149,3.149,0,0,1,.722-1.424,1.885,1.885,0,0,1-.521.181C9.845-46.562,9.1-45.611,8.249-45.5c-.615.08-.949-.253-.949-.743a1.728,1.728,0,0,1,.2-.748A2.031,2.031,0,0,1,8.77-48.148a.446.446,0,0,1,.234.02.8.8,0,0,1,.394.307c.1.188-.007.428-.134.689a2.3,2.3,0,0,0-.12.273c-.047.138-.073.173-.24.113a.34.34,0,0,1-.234-.334,1.767,1.767,0,0,1,.154-.466c.067-.141.133-.275.1-.3-.087-.052-.515.387-.8.956a1.772,1.772,0,0,0-.2.723c0,.264.114.425.307.412.655-.06,1.369-1.069,1.717-1.886a.238.238,0,0,1-.187-.252,1.2,1.2,0,0,1,.668-.884c.14-.018.194.057.194.195a1.965,1.965,0,0,1-.127.544,2.022,2.022,0,0,0,.581-.345c.1-.082.207-.121.294-.044a.554.554,0,0,1,.187.4.422.422,0,0,1-.114.266,4.088,4.088,0,0,0-.722,1.148.9.9,0,0,0-.053.289c0,.157.053.244.154.238.211-.01.554-.4.762-.826a8.193,8.193,0,0,1,.895-1.667.177.177,0,0,1,.287-.037.4.4,0,0,1,.1.276,3.537,3.537,0,0,1-.421.969l-.055.1c-.091.173-.178.343-.245.49-.12.267-.14.5.007.482.174-.023.528-.5.869-1.041.394-.654.568-1.1.808-1.423.094-.131.2-.17.281-.074a.455.455,0,0,1,.1.314,2.113,2.113,0,0,1-.374.9,2.858,2.858,0,0,0-.454,1.025c0,.113.04.171.127.159.161-.021.387-.283.591-.59a13.387,13.387,0,0,1,1.012-1.922c.087-.13.187-.137.254-.033a.513.513,0,0,1,.094.289.838.838,0,0,1-.02.172,2.093,2.093,0,0,1,.875-.616c.214-.028.354.18.354.444a2.018,2.018,0,0,1,.868-.571c.194-.019.3.137.3.344a2.108,2.108,0,0,1-.414.951,1.874,1.874,0,0,0-.361.812c0,.145.067.236.174.223.207-.027.534-.509.782-.924a.251.251,0,0,1,.052-.064A8.157,8.157,0,0,1,19.713-50.858Z",
    transform: "translate(-3 51)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-59,81.666H183.675V-87H-59Z",
    transform: "translate(59 87)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.683-10.892l4.243-.44a.5.5,0,0,1,.554.422l0,.018a.48.48,0,0,1-.415.541l-.017,0-4.243.44a.5.5,0,0,1-.554-.422l0-.018a.48.48,0,0,1,.415-.541Z",
    transform: "translate(-1.246 11.335)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3-18.035H21.875V-21H3Z",
    transform: "translate(-3 21)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.644-15.892l4.243-.44a.5.5,0,0,1,.554.422l0,.018a.48.48,0,0,1-.415.541l-.017,0-4.243.44a.5.5,0,0,1-.554-.422l0-.018a.48.48,0,0,1,.415-.541Z",
    transform: "translate(-30.206 16.335)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.446-19.892l4.243-.44a.5.5,0,0,1,.554.422l0,.018a.48.48,0,0,1-.415.541l-.017,0-4.243.44a.5.5,0,0,1-.554-.422l0-.018a.48.48,0,0,1,.415-.541Z",
    transform: "translate(-58.008 20.335)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.089-21.892l4.243-.44a.5.5,0,0,1,.554.422l0,.018a.48.48,0,0,1-.415.541l-.017,0-4.243.44a.5.5,0,0,1-.554-.422l0-.018a.48.48,0,0,1,.415-.541Z",
    transform: "translate(-84.652 22.335)",
    fill: "none",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-718 -420)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 43)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.5,
    height: 56,
    transform: "translate(816 377)",
    fill: "#19d8ac"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 66.5,
    height: 56.5,
    transform: "translate(750 377)",
    fill: "#0058ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,0H65a0,0,0,0,1,0,0V55a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3A3,3,0,0,1,3,0Z",
    transform: "translate(752 379)",
    fill: "#252c3d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 23.5,
    height: 55,
    transform: "translate(816.5 379)",
    fill: "#282f42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(761.56 409.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.193,
    height: 14.03,
    rx: 3,
    fill: "#323949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4070.119,9387.108H4114.3",
    transform: "translate(-4066.817 -9384.13)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4070.119,9387.108H4089.7",
    transform: "translate(-4066.817 -9380.829)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3,0H48.193a3,3,0,0,1,3,3V7.894a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3A3,3,0,0,1,3,0Z",
    transform: "translate(761.56 426.106)",
    fill: "#323949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4070.12,9387.108h4.972",
    transform: "translate(-3307.322 -8990.212)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4073.062,9395.453h46.078",
    transform: "translate(-3309.026 -8991.669)",
    fill: "none",
    stroke: "#4d5565",
    strokeLinecap: "round",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4070.12,9387.108h4.972",
    transform: "translate(-3248.698 -8990.212)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.476,0H19.817a0,0,0,0,1,0,0V4.952a0,0,0,0,1,0,0H2.476A2.476,2.476,0,0,1,0,2.476v0A2.476,2.476,0,0,1,2.476,0Z",
    transform: "translate(820.183 401.346)",
    fill: "#4d5565"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4070.121,9387.108h15.116",
    transform: "translate(-3261.084 -9001.442)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4070.119,9387.108h29.888",
    transform: "translate(-3305.258 -8958.025)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(758.274 381.156)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.448 -5.93)",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.146 5.774)",
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.302 0.156)",
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-49H18.38v8.236H-1Z",
    transform: "translate(0.831 48.835)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.448 -5.93)",
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.146 10.773)",
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.007 1.69)",
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.296 -1.592)",
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.859-15.527l5.413-.65.288,2.293-5.413.65Z",
    transform: "translate(-1.22 16.971)",
    fill: "#0057ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.887 0.866)",
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.585 -0.768)",
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.81-20.723l5.746-.69.3,2.411-5.746.69Z",
    transform: "translate(-23.629 21.344)",
    fill: "#5e00ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.572 0.207)",
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.27 -0.11)",
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.611-24.723l5.746-.69.3,2.411-5.746.69Z",
    transform: "translate(-46.745 24.685)",
    fill: "#c000ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.063 -0.122)",
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.76 0.22)",
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.435-25.142l5.558-.667.27,2.151-5.558.667Z",
    transform: "translate(-69.048 25.017)",
    fill: "#ff0069"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemePreviewDark);
export default __webpack_public_path__ + "static/media/theme-preview-dark.cae85daf8787246cdb721841fb7465c7.svg";
export { ForwardRef as ReactComponent };